import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageMetadata, getStructuredData, shareImage } from '../../data/pageMetadata';
import { useNews } from './NewsProvider';

export default function PageMetadata() {
  const { pathname } = useLocation();
  const { articles } = useNews();
  useEffect(() => {
    const data = getPageMetadata(pathname, articles);
    document.title = data.title;
    document.documentElement.lang = data.locale.html;
    const setMeta = (attribute, key, value) => {
      let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.appendChild(element); }
      element.setAttribute('content', value);
    };
    setMeta('name', 'description', data.description);
    setMeta('name', 'robots', data.index ? 'index, follow, max-image-preview:large' : 'noindex, follow');
    ['og:title', 'twitter:title'].forEach(key => setMeta(key.startsWith('og:') ? 'property' : 'name', key, data.title));
    ['og:description', 'twitter:description'].forEach(key => setMeta(key.startsWith('og:') ? 'property' : 'name', key, data.description));
    setMeta('property', 'og:url', data.canonical);
    setMeta('property', 'og:locale', data.locale.og);
    setMeta('property', 'og:image', shareImage);
    setMeta('name', 'twitter:image', shareImage);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', data.canonical);
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach(item => item.remove());
    if (data.index) [...data.alternates, { language: 'x-default', url: data.alternates[0].url }].forEach(item => { const link = document.createElement('link'); link.rel = 'alternate'; link.hreflang = item.language; link.href = item.url; document.head.appendChild(link); });
    const schema = document.getElementById('bz-structured-data');
    if (schema) schema.textContent = JSON.stringify(getStructuredData(pathname, articles));
  }, [pathname, articles]);
  return null;
}
